import { PropsWithChildren } from 'react';

import { MqSwitch } from '@fhs/ui';

import { AuthContainerDesktop } from './auth-container-desktop';
import { AuthContainerMobile } from './auth-container-mobile';

export type AuthContainerProps = {
  hasBackNavigation?: boolean;
} & PropsWithChildren;

export function AuthContainer({ children }: AuthContainerProps) {
  return (
    <MqSwitch
      $ltDesktop={() => <AuthContainerMobile>{children}</AuthContainerMobile>}
      $gteDesktop={() => <AuthContainerDesktop>{children}</AuthContainerDesktop>}
    />
  );
}
